import "./styles.css";
import { useRef, useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../context/ConfigContext";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import { ProductBottleIcon } from "../icons/ProductBottleIcon";
import { GeneralInfoAi, ResultBasedInfoAi } from "./Utilities";
import { MdInfoOutline } from "react-icons/md";

export const Results = ({ results, onProductClick, onExitClick }) => {
  const { t } = useTranslation(["aiResults", "customAiInfo"]);
  const imgRef = useRef(null);
  const detailsRef = useRef(null);
  const [selectedResult, setSelectedResult] = useState(Object.keys(results)[0]);
  const { uid } = useUID();
  const trackEvent = useAmplitude();
  const { configData } = useConfig();

  useEffect(() => {
    // Track user visits Results Page
    trackEvent("webapp_user_visited_results_page", uid, "results");
  }, [uid, trackEvent, configData.recommendationEnabled]);

  const scrollToDetailText = () => {
    if (detailsRef.current) {
      detailsRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="result">
      <div className="result-short-info">
        <img
          ref={imgRef}
          className="background-image"
          src={`data:image/png;base64, ${results[selectedResult].image}`}
          alt="Result"
        />
        <div className="results-close-wrapper">
          <IoClose
            className="results-close-icon"
            onClick={() => onExitClick()}
          />
        </div>
        <div className="result-info-container">
          <div className="result-type" onClick={scrollToDetailText}>
            <p className="result-info-title">{t(selectedResult)}</p>
            <MdInfoOutline />
          </div>
          <h4 className="result-info-decision">
            {t(results[selectedResult].value)}
          </h4>
        </div>
        <div className="result-types-details-wrapper">
          <div className="result-types-button-wrapper">
            {Object.keys(results).map((key) => (
              <div
                key={key}
                className={`result-button ${selectedResult === key ? "selected" : ""}`}
                onClick={() => {
                  setSelectedResult(key);
                }}
              >
                {t(key)}
              </div>
            ))}
          </div>
        </div>
        <div className="result-bottom-buttons-container">
          <button className="recommend-button" onClick={onProductClick}>
            <p>{t("Product Recommendation")}</p>
            <ProductBottleIcon />
          </button>
        </div>
        <div className="text-info-background" />
      </div>
      <div ref={detailsRef} className="result-detail-info">
        <p className="result-detail-text">
          {t(
            GeneralInfoAi.includes(selectedResult)
              ? "customAiInfo:" +
                  selectedResult.toLowerCase().split(" ").join("-") +
                  "-info"
              : ResultBasedInfoAi.includes(selectedResult)
                ? "customAiInfo:" +
                  selectedResult.toLowerCase().split(" ").join("-") +
                  "-" +
                  results[selectedResult].value
                    .toLowerCase()
                    .split(" ")
                    .join("-") +
                  "-info"
                : "customAiInfo:" +
                  results[selectedResult].value
                    .toLowerCase()
                    .split(" ")
                    .join("-") +
                  "-info",
          )}
        </p>
      </div>
    </div>
  );
};
